





























































import { Component, Vue, Prop } from 'vue-property-decorator'
import TsTable from '@/components/TsTable/TsTable.vue'
import { TbData } from '@/components/TsTable/index'
import { fetchRoleList, createRole, deleteRole } from '@/api/manage/roleManage'
import { FetchRoleParams } from '@/types/manage/roleManage'
import { Form } from 'element-ui'

@Component({
  name: '',
  components: {
    TsTable
  }
})
export default class extends Vue {
 @Prop({ required: true }) private dataObj!: any
  dialogVisible = false
  form = {
    name: '',
    type: 'create',
    id: '',
    description: ''
  }

  searchParams: FetchRoleParams = {
    page: 0,
    size: 20
  }

  tableData: TbData = {
    data: [],
    currentPage: this.searchParams.page,
    pageSize: this.searchParams.size,
    total: 0
  };

  tableTitleObj = {
    title: this.dataObj.title,
    options: {
      dropdown: false,
      type: 'settingRole',
      name: '新增',
      arr: [
        {
          type: 'settingRole',
          name: '新增'
        }
      ]
    }
  };

  tableHead = [
    {
      propName: 'name',
      labelName: this.dataObj.tbHead1,
      options: {
        type: 'search'
      }
    },
    {
      propName: 'userCount',
      labelName: '包含用户数量',
      options: {
        type: 'sort',
        optionArr: [
          {
            type: 'rise',
            name: '升序',
            icon: 'el-icon-top'
          },
          {
            type: 'desc',
            name: '降序',
            icon: 'el-icon-bottom'
          }
        ]
      }
    },
    {
      propName: 'description',
      labelName: '备注'
    },
    {
      type: 'edit',
      labelName: '操作',
      propName: 'edit',
      options: {
        dropdown: true,
        type: 'settingRole',
        name: '编辑权限',
        btnType: 'text',
        arr: [
          {
            type: 'editRole',
            name: '修改名称',
            btnType: 'warning'
          },
          {
            type: 'editDes',
            name: '调整备注'
          },
          {
            type: 'delete',
            name: '删除'
          }
        ]
      }
    }
  ];

  tableSelectOpt = [
    {
      type: 'error',
      name: '批量删除',
      icon: 'el-icon-delete'
    },
    {
      type: 'info',
      name: '信息',
      icon: 'el-icon-info'
    }
  ];

  created () {
    this.handleSearch()
  }

  get getTitle () {
    if (this.form.type === 'create') {
      return '新增角色'
    } else if (this.form.type === 'edit') {
      return '编辑名称'
    } else {
      return '调整备注'
    }
  }

  handleSearch () {
    const params = Object.assign({}, this.searchParams)
    fetchRoleList(this.dataObj.url, params)
      .then(res => {
        if (res.statusCode === 0 && res.data) {
          const { content, totalElements } = res.data;
          (this.tableData as TbData).data = content;
          (this.tableData as TbData).total = totalElements
        }
      })
  }

  confirm () {
    (this.$refs.roleForm as Form).validate(async valid => {
      console.log('valid', valid)
      if (valid) {
        let p = {}
        if (this.form.type === 'create') {
          p = { name: this.form.name }
        } else if (this.form.type === 'edit') {
          p = { name: this.form.name, id: this.form.id, description: this.form.description }
        } else {
          p = { description: this.form.description, id: this.form.id, name: this.form.name }
        }
        const res = await createRole(this.dataObj.addUrl, p)
        if (res.statusCode === 0 && res.data) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.dialogVisible = false
          this.handleSearch()
        }
      }
    })
  }

  handleTableTitleBtn (p1: string, p2: string) {
    console.log('p1', p1)
    console.log('p2', p2)
    if (p2) {
      switch (p1) {
        case 'settingRole':
          this.settingRole(p2)
          break
        case 'editRole':
          this.editRole(p2)
          break
        case 'editDes':
          this.editDes(p2)
          break
        case 'delete':
          this.delete(p2)
          break
      }
    } else {
      this.form.type = 'create'
      this.form.name = ''
      this.dialogVisible = true
      console.log('111')
    }
  }

  settingRole (data: any) {
    this.$router.push({
      name: this.dataObj.pathname,
      query: {
        roleId: data.id
      }
    })
  }

  handleClose () {
    this.dialogVisible = false
  }

  editRole (data: any) {
    console.log('editRole')
    this.form.type = 'edit'
    this.form.id = data.id
    this.form.name = data.name
    this.form.description = data.description
    this.dialogVisible = true
  }

  editDes (data: any) {
    console.log('editDes')
    this.form.type = 'editDes'
    this.form.id = data.id
    this.form.name = data.name
    this.form.description = data.description
    this.dialogVisible = true
  }

  async delete (data: any) {
    console.log('del data', data)
    const res = await deleteRole(this.dataObj.delUrl, {
      roleId: data.id
    })
    if (res.statusCode === 0 && res.success) {
      this.$message.success('删除成功')
      this.handleSearch()
    }
  }

  handleSizeChange (size: number) {
    console.log('size', size)
    this.searchParams.size = size
    this.handleSearch()
  }

  handleCurrentChange (current: number) {
    this.searchParams.page = current
    this.handleSearch()
  }

  handleFilter (tags: object[]) {
    if (tags.length) {
      tags.forEach((item: any) => {
        const key = item.type
        if (item.params.opt.type) {
          this.searchParams.sortField = key
          this.searchParams.direction = item.params.opt.type
        } else {
          this.searchParams[key] = item.params.opt.value || item.params.opt.type
        }
      })
    } else {
      this.searchParams = {
        page: 0,
        size: 20
      }
    }
    console.log('过滤结果：', tags)
    this.handleSearch()
  }

  handleSelectInfo () {
    console.log('5')
  }

  handleTableFirst () {
    console.log('6')
  }
}
